<template>
  <div class="search-area container">
    <form>
      <div class="row">
        <div class="form-group col-6">
          <label>Template name</label>
          <input class="form-control" type="text" v-model="conditions.name" />
        </div>

        <div class="form-group col-2">
          <label>Month</label>
          <select class="form-control" v-model="conditions.month">
            <option v-for="month of [1,2,3,4,5,6,7,8,9,10,11,12]" :key="month" :value="month">
              {{ month }}
            </option>
          </select>
        </div>
      </div>
    </form>

    <div class="d-flex justify-content-end">
      <b-button pill variant="outline-secondary" @click="reset" class="mr-2" >
        Reset
      </b-button>
      <b-button pill variant="secondary" @click="search(1)">
        Search
      </b-button>
    </div>
  </div>
</template>

<script lang="ts">
import { MailTemplateConditions } from '@/store/mails/templates/types'
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class MailsSendBulkMailTemplateConditions extends Vue {
  private conditions: MailTemplateConditions = {
    name: null,
    month: null,
  }

  /**
   * メールテンプレートを検索
   */
  private search(page: number = 1): void {
    this.$emit('changeConditions', this.conditions)
  }

  /**
   * 検索条件を削除して表示
   */
  private reset(): void {
    this.conditions = {
      name: null,
      month: null,
    }
    this.search()
  }
}
</script>
